module.exports = __webpack_public_path__ + "static/media/qyj2_dl_bar.78248ab8.png";